var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{staticClass:"pos-print",attrs:{"id":"barcode_pos_print"}},[_c('div',{staticClass:"printContent"},[_vm._l((parseInt(_vm.print_items)),function(item){return [_c('svg',{domProps:{"innerHTML":_vm._s(_vm.svgData)}}),_c('br')]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }